import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Modal, RangeSlider } from 'rsuite'
import Select  from 'react-select'
import useAuth from '../../../auth/useAuth'

import CustomTooltip from '../../CommonComponents/CustomTooltip'

import { getBrandRecommendations } from '../../../redux/actions/targeting'

const RefineModal = ({ show, category, onRefine, onClose }) => {
  const dispatch = useDispatch()
  const { getAccessTokenSilently } = useAuth()

  const [isLoading, setIsLoading] = useState(false)
  const [brandData, setBrandData] = useState([])
  const [selectedBrands, setSelectedBrands] = useState([])
  const [minValue, setMinValue] = useState('')
  const [maxValue, setMaxValue] = useState('')
  const [rating, setRating] = useState([0, 5])

  useEffect(() => {
    if (category) {
      (async () => {
        setIsLoading(true)
        const accessToken = await getAccessTokenSilently()
        const data = await dispatch(getBrandRecommendations(accessToken, {
          categoryId: category.id,
        }))
        setBrandData(data)
        setIsLoading(false)
      })()
    }
  }, [category]) // eslint-disable-line

  const handleRefine = () => {
    if (selectedBrands.length === 0) {
      onRefine(category, {
        brandId: null,
        brandName: null,
        priceFrom: minValue !== '' ? minValue : null,
        priceTo: maxValue !== '' ? maxValue : null,
        ratingValue: (rating[1] - rating[0]) !== 5 ? `${rating[0]}-${rating[1]}` : null,
      })
    }
    else {
      selectedBrands.forEach((brand) => {
        onRefine(category, {
          brandId: brand.id,
          brandName: brand.name,
          priceFrom: minValue !== '' ? minValue : null,
          priceTo: maxValue !== '' ? maxValue : null,
          ratingValue: (rating[1] - rating[0]) !== 5 ? `${rating[0]}-${rating[1]}` : null,
        })
      })
    }
    onClose()
  }

  return (
    <Modal className="refine-modal" backdrop="static" show={show}>
      <Modal.Header onHide={() => { onClose() }}>
        <Modal.Title>
          Refine category: { category ? category.name || category.na : '' }
          <CustomTooltip placement="right">
            <p>Refine your targeting by specific brands, price range, and star ratings.</p>
          </CustomTooltip>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="field-row">
          <div className="field-wrapper">
            <div className="field-name">
              Brand
            </div>
            <Select
              options={brandData}
              getOptionLabel={brand => brand.name}
              getOptionValue={brand => brand.id}
              value={selectedBrands}
              isMulti
              isLoading={isLoading}
              closeMenuOnSelect={false}
              placeholder="Select Brands..."
              onChange={(option) => { setSelectedBrands(option) }}
            />
          </div>
        </div>
        <div className="field-row">
          <div className="field-wrapper">
            <div className="field-name">
              Price Range
            </div>
            <div className="price-range-input">
              <input
                type="number"
                placeholder="No min"
                value={minValue}
                onChange={(event) => { setMinValue(event.target.value) }}
              />
              <span>-</span>
              <input
                type="number"
                placeholder="No max"
                value={maxValue}
                onChange={(event) => { setMaxValue(event.target.value) }}
              />
            </div>
          </div>
        </div>
        <div className="field-row">
          <div className="field-wrapper">
            <div className="field-name">
              Review star ratings
            </div>
            <RangeSlider
              min={0}
              max={5}
              graduated
              progress
              renderMark={mark => mark}
              value={rating}
              onChange={setRating}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="rs-btn rs-btn-primary"
          onClick={handleRefine}
        >
          Refine
        </button>
        <button type="button" className="rs-btn rs-btn-subtle" onClick={() => onClose()}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default RefineModal
